
































































import { fetchContratosSiga } from './fetchContratosSiga';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';

@Component({
  components: {
    DatePicker,
  },
})
export default class Formulario extends ComponenteBaseStepper {
  fileName: any;
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];

  eliminarNombre() {
    this.formFields.archivo.value = '';
  }

  cargarNombre() {
    let input = document.getElementById('archivoExcel') as HTMLInputElement;
    this.formFields.archivo.value = input.files[0].name;
  }

  mounted() {}
  idkey: number = 0;
  itemsDelExcel: any = 0;

  subirExcel() {
    let input = document.getElementById('archivoExcel') as HTMLInputElement;
    let file = input.files[0];
    console.log(file);

    // Verifica que el archivo sea un CSV
    if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
      this.$snotify.warning('Por favor, sube un archivo CSV o un Excel', 3000);
      return;
    }
    this.$emit('archivoImportado', file);
    this.idkey += 1;
  }

  descargarPlantilla() {
    let headers = {
      header: [
        'Nombre',
        'Fecha de creación',
        'RUT',
        'Cliente',
        'Razón para el estado',
        'Autor',
        'Cant. Equipos',
        'Cant. Perifericos',
        'Ejecutivo de Venta',
        'Propietario',
        'Motivo de la Baja',
        'Situación Baja',
        'Tipo',
        'F. Aprobador 1',
        'F.Aprobador 2',
        'F.Aprobador 3',
      ],
    };
    let datos: any = [{}];
    const ws = utils.json_to_sheet(datos, headers);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    writeFileXLSX(wb, 'Plantilla.csv');
    this.$snotify.success('Plantilla Excel Generada con éxito', 3000);
  }

  cerrarModal() {
    this.$emit('modalAsociacionEmit', false);
  }

  formFields: {
    archivo: any;
  } = {
    archivo: {
      label: 'Seleccione Archivo',
      value: '',
    },
  };

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dictionaryFormErrors: any = {};
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
